import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { LISTING_PAGE_CONTAINER_WIDTH } from 'screens/ListingPage/styled';

function getHeaderHeight(isMobile: boolean) {
  if (isMobile) return 56;
  return 72;
}

export const Root = styled.div(({ theme }) => ({
  minHeight: `calc(100vh - ${getHeaderHeight(false)}px)`,
  width: '100%',
  maxWidth: `${LISTING_PAGE_CONTAINER_WIDTH}px`,
  margin: '0 auto',
  display: 'flex',
  gap: theme.spacing(5),
  marginTop: `${getHeaderHeight(false)}px`,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  backgroundColor: theme.colors.neutrals.white,
  padding: '0 60px',
  [theme.media.createObjectMediaQuery({ at: 2 })]: {
    padding: theme.spacing(3),
    minHeight: `calc(100vh - ${getHeaderHeight(true)}px)`,
    marginTop: `${getHeaderHeight(true)}px`,
  },
  [theme.media.createObjectMediaQuery({ at: 1 })]: {
    padding: theme.spacing(2),
    minHeight: `calc(100vh - ${getHeaderHeight(true)}px)`,
    marginTop: `${getHeaderHeight(true)}px`,
  },
}));

export const SideBar = styled.div(({ theme }) => ({
  flexBasis: '328px',
  flexDirection: 'column',
  flexShrink: 0,
  display: 'flex',
}));

export const Hint = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
  cursor: 'pointer',
  textAlign: 'center',
}));

export const Main = styled.div(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    marginBottom: theme.spacing(11),
  },
}));

export const Header = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.neutrals.white,
  boxShadow: theme.shadow.level2,
  height: `${getHeaderHeight(false)}px`,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 999,
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    height: `${getHeaderHeight(true)}px`,
  },
}));

export const BackBtn = styled(SmallText)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.colors.neutrals.grey3,
  padding: theme.spacing(0.75, 2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  '> svg': {
    'path': {
      fill: theme.colors.neutrals.grey3,
    },
  },
}));

export const ExtraBtnWrapper = styled(SmallText)(({ theme }) => ({
  padding: `0 ${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  '[data-auto="select-menu"]': {
    zIndex: 9999,
  },
}));
